import { render } from "./Withdraw.vue?vue&type=template&id=00c8c5da&scoped=true"
import script from "./Withdraw.vue?vue&type=script&lang=js"
export * from "./Withdraw.vue?vue&type=script&lang=js"

import "./Withdraw.vue?vue&type=style&index=0&id=00c8c5da&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1672060877/src/vivamo-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c8c5da"]])

export default __exports__